import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_EXAM,
  GET_EXAMS,
  GET_EXAMS_BY_FILTER,
  ADD_EXAM,
  ADD_EXAMS_UPLOAD,
  UPDATE_EXAM,
  DELETE_EXAM,
  GET_EXAMS_PAGINATION,
} from '@/queries/modules/examination/exam.js';

export async function getExams(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_EXAMS,
        fetchPolicy: 'network-only'
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setExams', data.getExams);
      context.commit('setSuccess', null);
      return data.getExams
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getExamsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_EXAMS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setExams', data.getExamsByFilter);
      context.commit('setSuccess', null);

      return data.getExamsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getExam(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_EXAM,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;


    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setExam', data.getExam);
      context.commit('setSuccess', null);
      return data.getExam
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}
export async function getExamsPagination(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_EXAMS_PAGINATION,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);

      return data.examsPagination;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function addExam(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_EXAM,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const exams = [...context.state.exams];
      exams.push(data.addExam);
      context.commit('setExams', exams);
      context.commit('setSuccess', newItemSuccess(data.addExam.nameLocal));

      return data.addExam;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addExamsUpload(context, payload) {
  context.commit('setProcessing', true);
  try {

    const result = await apolloClient
      .mutate({
        mutation: ADD_EXAMS_UPLOAD,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', updateItemSuccess(data.addExamsUpload.length));

      return data.addExamsUpload
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateExam(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_EXAM,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.exams.findIndex(item => item.id === data.updateExam.id);
      const exams = [
        ...context.state.exams.slice(0, index),
        data.updateExam,
        ...context.state.exams.slice(index + 1)
      ];
      context.commit('setExams', exams);
      context.commit('setSuccess', updateItemSuccess(data.updateExam.nameLocal));

      return data.updateExam
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteExam(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_EXAM,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.exams.findIndex(item => item.id === data.deleteExam.id);
      const exams = [
        ...context.state.exams.slice(0, index),
        ...context.state.exams.slice(index + 1)
      ];
      context.commit('setExams', exams);
      context.commit('setSuccess', deleteItemSuccess(data.deleteExam.nameLocal));

      return data.deleteExam
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

